// src/views/scannedData/ScanRow.js
import PropTypes from "prop-types";
import { truncate, formatDate, formatTime } from "./utils";
import "./ScanRow.css";

export default function ScanRow({
  scan,
  isSelected,
  onSelect,
  onRequestUpload,
  onEditAddress,
  isAdmin,
  isViewingOtherUser,
  status,
  onUpdateStatus,
}) {
  const address =
    scan.editedAddress || scan.googleMapAddress || "";

  const hasImage = Boolean(scan.urlToReadImage);
  const rtu = Number(scan.requestToUpload ?? 0);

  const addressConfirmed =
    scan.addedToMautic !== undefined &&
    scan.addedToMautic !== null;

  const ts = scan.createTimestamp ?? scan.timestamp ?? 0;

  return (
    <tr
      className={isSelected ? "selected-row" : ""}
      onClick={() => onSelect(scan)}
    >
      <td>
        {addressConfirmed ? (
          address
        ) : isViewingOtherUser ? (
          <span className="not-available">Not Avail</span>
        ) : (
          <button
            className="request-upload-btn confirm-btn"
            onClick={(e) => onEditAddress(e, scan)}
          >
            Confirm
          </button>
        )}
      </td>

      <td>{formatDate(ts)}</td>
      <td>{formatTime(ts)}</td>

      <td>
        {!hasImage ? (
          isViewingOtherUser ? (
            <span className="not-available">Not Avail</span>
          ) : rtu >= 3 ? (
            <span className="rtu-blocked">Blocked</span>
          ) : (
            <button
              className="request-upload-btn"
              onClick={(e) => onRequestUpload(e, scan)}
            >
              TakePic
            </button>
          )
        ) : (
          <span className="rtu-count">Uploaded</span>
        )}
      </td>

      {/* Status Column (Visible to All) */}
      <td className="admin-actions-cell">
        {isAdmin && isViewingOtherUser && hasImage ? (
          // Admin viewing another user's data with image - show single icon or PENDING button
          status === "pending" ? (
            <button
              onClick={(e) => onUpdateStatus(e, scan, "")}
              className="status-pending-btn"
              title="Click to set status"
            >
              PENDING
            </button>
          ) : (
            <button
              onClick={(e) => onUpdateStatus(e, scan, status)}
              className={`status-icon-single status-icon-${status}`}
              title={`${status.charAt(0).toUpperCase() + status.slice(1)} - Click to change`}
            >
              {status === "verified" ? "✔" : status === "disputed" ? "?" : "✘"}
            </button>
          )
        ) : (
          // Non-admin or admin viewing own data - show badge
          <span className={`status-badge ${status || "pending"}`}>
            {status ? status.charAt(0).toUpperCase() + status.slice(1) : "Pending"}
          </span>
        )}
      </td>


    </tr>
  );
}

ScanRow.propTypes = {
  scan: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onRequestUpload: PropTypes.func,
  onEditAddress: PropTypes.func,
  isAdmin: PropTypes.bool,
  isViewingOtherUser: PropTypes.bool,
  status: PropTypes.string,
  onUpdateStatus: PropTypes.func,
};
